import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TablaArchivos from './TablaArchivos';
import TablaMaquinaria from './TablaMaquinaria';
import {findNumberCad} from '../funciones/FindNumber'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    padding:0,
    marginLeft:.6+'rem',
  },
}));

export default function MenuTab({listArchivos, contrato, llenarListFile, listMaquinaria, getListMaquinaria   }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const cadena = localStorage.getItem("UserOperacion")+"|"; 
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Box  >
      <AppBar position="static" color="transparent"  >
        <Tabs 
          value={value} onChange={handleChange}
          aria-label="simple tabs example" indicatorColor="secondary"
          textColor="secondary" centered                        
        >
          {findNumberCad('|40|',cadena)?  <Tab label="Archivos" {...a11yProps(0)} /> :null}
          {findNumberCad('|42|',cadena) ?   <Tab label="Maquinaria" {...a11yProps(1)} />:null}
        </Tabs>
      </AppBar>
      </Box>
      <TabPanel value={value} index={0} >
        <TablaArchivos datos={listArchivos} contrato={contrato}  llenarListFile={llenarListFile}   />
      </TabPanel>
      <TabPanel value={value} index={1} >
        <TablaMaquinaria datos={listMaquinaria} contrato={contrato}  llenarListFile={getListMaquinaria} />
      </TabPanel>
    </div>
  );
}